/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import * as classes from './styles'

interface IProps {
  text: string
  color: string
  className?: string
}

const Badge: FC<IProps> = ({ text, color, className }) => (
  <Typography css={classes.badge(color)} className={className} variant="body2">
    {text}
  </Typography>
)

export default Badge
